import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import InputColor from '../../layout/input/InputColor';

class Desktop extends AbstractComponent {            
    render() {
        return(                                                                 
            <Fragment>   
                <InputColor
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="background_header_desktop"
                    nome="background_header_desktop"                    
                    value={this.props.form.background_header_desktop}
                    defaultValue={this.props.form.background_header_desktop}
                    erro={this.props.erroForm.background_header_desktop}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Header
                </InputColor> 
                
                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_icon_header_desktop"
                    nome="color_icon_header_desktop"                    
                    value={this.props.form.color_icon_header_desktop}
                    defaultValue={this.props.form.color_icon_header_desktop}
                    erro={this.props.erroForm.color_icon_header_desktop}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Icon Header
                </InputColor> 

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="cor_lbl_icon_menu_top"
                    nome="cor_lbl_icon_menu_top"                    
                    value={this.props.form.cor_lbl_icon_menu_top}
                    defaultValue={this.props.form.cor_lbl_icon_menu_top}
                    erro={this.props.erroForm.cor_lbl_icon_menu_top}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Label Icon Header
                </InputColor>

                <InputColor
                    md={4} 
                    xs={12} 
                    sm={4} 
                    lg={4}
                    id="color_primaria_header"
                    nome="color_primaria_header"                    
                    value={this.props.form.color_primaria_header}
                    defaultValue={this.props.form.color_primaria_header}
                    erro={this.props.erroForm.color_primaria_header}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Primaria Header
                </InputColor> 

                <InputColor
                    md={4} 
                    xs={12} 
                    sm={4} 
                    lg={4}
                    id="color_secundaria_header"
                    nome="color_secundaria_header"                    
                    value={this.props.form.color_secundaria_header}
                    defaultValue={this.props.form.color_secundaria_header}
                    erro={this.props.erroForm.color_secundaria_header}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Secundaria Header
                </InputColor> 

                <InputColor
                    md={4} 
                    xs={12} 
                    sm={4} 
                    lg={4}
                    id="color_secundaria_header_hover"
                    nome="color_secundaria_header_hover"                    
                    value={this.props.form.color_secundaria_header_hover}
                    defaultValue={this.props.form.color_secundaria_header_hover}
                    erro={this.props.erroForm.color_secundaria_header_hover}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Secundaria Header Hover
                </InputColor>                 

                <InputColor
                    md={4} 
                    xs={12} 
                    sm={4} 
                    lg={4}
                    id="color_badge_border"
                    nome="color_badge_border"                    
                    value={this.props.form.color_badge_border}
                    defaultValue={this.props.form.color_badge_border}
                    erro={this.props.erroForm.color_badge_border}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Badge Border
                </InputColor>

                <InputColor
                    md={4} 
                    xs={12} 
                    sm={4} 
                    lg={4}
                    id="background_badge_desktop"
                    nome="background_badge_desktop"                    
                    value={this.props.form.background_badge_desktop}
                    defaultValue={this.props.form.background_badge_desktop}
                    erro={this.props.erroForm.background_badge_desktop}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Badge
                </InputColor>

                <InputColor
                    md={4} 
                    xs={12} 
                    sm={4} 
                    lg={4}
                    id="color_badge_desktop"
                    nome="color_badge_desktop"                    
                    value={this.props.form.color_badge_desktop}
                    defaultValue={this.props.form.color_badge_desktop}
                    erro={this.props.erroForm.color_badge_desktop}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Badge
                </InputColor>                                
            </Fragment>
        )
    }
}

export default Desktop;